// Libraries
var React = require('react');

var VideoPlaceholder = require('./VideoPlaceholder');

// Styles
require('./VideoModule.scss');

class MobileVideoModule extends React.Component {

	constructor(props) {

		super(props);
	}


	render() {
		const appDeeplink = 'yc-fa-tot://action/MEDIA_ITEM?id=GUID_' + this.props.data.entryId;
		return (
			<div className="Video" ref={video => this.videoRef = video}>
				<div className="Video__wrapper">
					<VideoPlaceholder
						thumbnail={this.props.data.thumbnail}
						membershipTier={this.props.data.membershipTier}
						articleLink={this.props.articleLink}
						externalLink={this.props.data.externalLink}
						caption={this.props.data.caption}
						type={this.props.data.type}
						appDeepLink={appDeeplink}
					/>
				</div>
			</div>
		)
	}
}

module.exports = MobileVideoModule;



// WEBPACK FOOTER //
// ./src/components/Video/MobileVideoModule.js